module.exports = __webpack_public_path__ + "static/traditions-technology-boost-bee-health-13cc0b8c41b4d3b8b341f13f06763c41.jpg";